module.exports = __webpack_public_path__ + "static/media/card-blog6.1fd32420.jpg";